/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_IndividualInputs */

const en_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individual Lessons`)
};

const es_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones individuales`)
};

const de_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelunterricht`)
};

const zh_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单节课程`)
};

const ar_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دروس فردية`)
};

const fr_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçons individuelles`)
};

const vi_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi học cá nhân`)
};

const sw_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masomo ya Mtu Binafsi`)
};

const th_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนส่วนบุคคล`)
};

const bs_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pojedinačne lekcije`)
};

const ja_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人レッスン`)
};

const ko_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인 레슨`)
};

const pt_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas avulsas`)
};

const it_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni individuali`)
};

const sv_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuella lektioner`)
};

const nl_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuele lessen`)
};

const da_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuelle lektioner`)
};

const nb_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enkelttimer`)
};

const fi_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityistunnit`)
};

const pl_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indywidualne lekcje`)
};

const ru_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индивидуальные уроки`)
};

const tr_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bireysel Dersler`)
};

const hi_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्यक्तिगत पाठ`)
};

const id_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran Individu`)
};

const ms_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran Individu`)
};

const cs_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuální lekce`)
};

const el_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ατομικά μαθήματα`)
};

const he_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים אישיים`)
};

const af_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuele lesse`)
};

const hu_prices_individual = /** @type {(inputs: Prices_IndividualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyéni órák`)
};

/**
* | output |
* | --- |
* | "Individual Lessons" |
*
* @param {Prices_IndividualInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_individual = /** @type {((inputs?: Prices_IndividualInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_IndividualInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_individual(inputs)
	if (locale === "de") return de_prices_individual(inputs)
	if (locale === "zh") return zh_prices_individual(inputs)
	if (locale === "ar") return ar_prices_individual(inputs)
	if (locale === "fr") return fr_prices_individual(inputs)
	if (locale === "vi") return vi_prices_individual(inputs)
	if (locale === "sw") return sw_prices_individual(inputs)
	if (locale === "th") return th_prices_individual(inputs)
	if (locale === "bs") return bs_prices_individual(inputs)
	if (locale === "ja") return ja_prices_individual(inputs)
	if (locale === "ko") return ko_prices_individual(inputs)
	if (locale === "pt") return pt_prices_individual(inputs)
	if (locale === "it") return it_prices_individual(inputs)
	if (locale === "sv") return sv_prices_individual(inputs)
	if (locale === "nl") return nl_prices_individual(inputs)
	if (locale === "da") return da_prices_individual(inputs)
	if (locale === "nb") return nb_prices_individual(inputs)
	if (locale === "fi") return fi_prices_individual(inputs)
	if (locale === "pl") return pl_prices_individual(inputs)
	if (locale === "ru") return ru_prices_individual(inputs)
	if (locale === "tr") return tr_prices_individual(inputs)
	if (locale === "hi") return hi_prices_individual(inputs)
	if (locale === "id") return id_prices_individual(inputs)
	if (locale === "ms") return ms_prices_individual(inputs)
	if (locale === "cs") return cs_prices_individual(inputs)
	if (locale === "el") return el_prices_individual(inputs)
	if (locale === "he") return he_prices_individual(inputs)
	if (locale === "af") return af_prices_individual(inputs)
	if (locale === "hu") return hu_prices_individual(inputs)
	return en_prices_individual(inputs)
});